module.exports = "/_next/static/images/bca-icon-4821ead16263f84283b83d29bc163525.svg";